import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://api-doc-truyen-e9c115ac57b8.herokuapp.com"; // || "http://localhost:3000";

export const getBaseUrl = () => {
  return API_BASE_URL;
};

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Thêm interceptor để tự động thêm token vào header
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default apiClient;